import { type StudyTreatmentInfo } from "../../gql-generated/types";
import { LocalStorage } from "../../shared/utils/browser";

const abExposureLoggingKey = "sc-ab-exposures";

const getStudyTreatmentInfoStr = ({ studyName, treatmentId }: StudyTreatmentInfo) => {
    if (studyName) {
        return `${studyName}:${treatmentId}`;
    }

    return "";
};

export class AbExposureLoggingStore extends LocalStorage {
    constructor(public override key: string) {
        super(key);

        const exposures = this.getItem<string[]>();
        if (!exposures) {
            super.setItem([]);
        }
    }

    override setItem(item: StudyTreatmentInfo): void {
        const handle = getStudyTreatmentInfoStr(item);
        const exposures = this.getItem<string[]>();

        if (handle && !exposures?.includes(handle)) {
            exposures?.push(handle);
            super.setItem(exposures);
        }
    }

    hasItem(item: StudyTreatmentInfo): boolean {
        const handle = getStudyTreatmentInfoStr(item);
        const exposures = this.getItem<string[]>();

        return !!exposures && exposures.includes(handle);
    }

    override removeItem(): void {
        super.removeItem();
        super.setItem([]);
    }
}

export const abExposureLoggingStore = new AbExposureLoggingStore(abExposureLoggingKey);
